import { createSelector } from '@reduxjs/toolkit';
import { selectDatesValue } from './selectDatesValue';
import { formatDate } from './utils';

export const selectDatesLabel = createSelector(selectDatesValue, dates => {
  const { from, to } = dates;

  if (!from || !to) {
    return 'Выберите даты';
  }

  const today = new Date();
  const isSameYear = from.getFullYear() === to.getFullYear();
  const isCurrentYear = from.getFullYear() === today.getFullYear();
  const shouldPrintYear = !isSameYear || !isCurrentYear;

  return `${formatDate(from, shouldPrintYear)} — ${formatDate(to, shouldPrintYear)}`;
});
